import {HandlerList} from "../../../infrastructure/handlers/handler-list";
import {ScoreboardWidgetFetchHandler} from "./scoreboard-widget.fetch-handler";
import {TimingHandler} from "../../../infrastructure/handlers/timing-handler";
import {BaseComponentLifecycleEventHandler} from "../../../infrastructure/handlers/base-component-lifecycle-event-handler";
import {FullGamePopulateDataHandler} from "../../../core/handlers/full-game.populate-data.handler";

export class ScoreboardWidgetHandlers extends HandlerList {
  static injectables = [ScoreboardWidgetFetchHandler, TimingHandler, FullGamePopulateDataHandler];

  constructor(
    scoreboardWidgetFetchHandler: ScoreboardWidgetFetchHandler,
    timingHandler: TimingHandler,
    fullGamePopulateDataHandler: FullGamePopulateDataHandler
  ) {
    super();

    [
      scoreboardWidgetFetchHandler,
      timingHandler,
      fullGamePopulateDataHandler
    ].forEach((handler: BaseComponentLifecycleEventHandler) => this.add(handler));
  }
}
